import { CmsApiResponse, MarketingBanner } from '@app/models/cms-api';
import { CmsServiceBase } from '@app/services/abstracts/cms-service.base';

export class CmsGlobalService extends CmsServiceBase {
    private static _instance: CmsGlobalService;

    public static get instance(): CmsGlobalService {
        if (!this._instance) {
            this._instance = new CmsGlobalService();
        }

        return this._instance;
    }

    async getMarketingBanner(
        preview = false,
        documentId?: string,
    ): Promise<MarketingBanner | null> {
        try {
            if (preview && documentId) {
                const response = await this.axiosInstance.get<CmsApiResponse<MarketingBanner>>(
                    `/marketing-banners/${documentId}`,
                    {
                        params: {
                            status: 'draft',
                            populate: '*',
                        },
                    },
                );

                const banner = response.data?.data;

                if (!banner) {
                    console.log('[CMS] Banner not found:', { documentId });
                    return null;
                }

                return banner;
            }

            const params = this.buildStrapiParams({
                sort: 'createdAt:desc',
                filters: {
                    config: {
                        isActive: {
                            $eq: true,
                        },
                    },
                },
                publicationState: preview ? 'preview' : 'live',
                populate: '*',
            });

            const response = await this.axiosInstance.get<CmsApiResponse<MarketingBanner[]>>(
                '/marketing-banners',
                { params },
            );

            const banners = response.data.data;

            if (!banners || banners.length === 0) {
                return null;
            }

            const now = new Date();

            const banner = banners.find(banner => {
                if (!banner.config || !banner.content) {
                    return false;
                }

                const startDate = banner.config.startDate ? new Date(banner.config.startDate) : now;
                const endDate = banner.config.endDate ? new Date(banner.config.endDate) : now;

                return now >= startDate && now <= endDate;
            });

            return banner || null;
        } catch (error) {
            console.warn('Failed to fetch marketing banner:', error);
            return null;
        }
    }
}
